<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
        <span class="icon">
            <i class="fi fi-ss-search-alt"></i>
            {{"OverDcSearch.Header" | translate}}
        </span>
    </h1>
</div>

<p-card>
    <p-accordion>
        <p-accordionTab
                header="{{ 'Common.Form.Header' | translate }}"
                [selected]="isSearchFormOpen">
            <form [formGroup]="searchForm">

                <div class="p-fluid formgrid grid">

                    <div class="col-12 md:col-6 lg:col-3 mb-3"><!-- 單選 貨主-->
                        <label>{{ 'OverDcSearch.Search.erpStorer' | translate }}</label>
                        <p-dropdown formControlName="erpStorer" [options]="storerOption"
                                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                    [showClear]="true"
                        >
                        </p-dropdown>

                        <div *ngIf="((submitted || searchForm.controls.erpStorer.touched) && searchForm?.controls?.erpStorer?.errors?.required )" >
                            <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
                        </div>
                    </div>

                    <div class="col-12 md:col-6 lg:col-3 mb-3"><!-- 單選 品牌-->
                        <label>{{ 'OverDcSearch.Search.brand' | translate }}</label>
                        <laas-dropdown appendTo="body" formControlName="brand" [options]="brandOptions"
                                    [showClear]="true"
                                    [filter]="true"
                                    filterBy="label"
                                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                    [virtualScroll]="true"
                                    [virtualScrollItemSize]="40"
                                    >
                        </laas-dropdown>
                    </div>

                    <div class="col-12 md:col-6 lg:col-3 mb-3"><!-- 單選 內部品牌-->
                        <label>{{ 'OverDcSearch.Search.internalBrand' | translate }}</label>
                        <laas-dropdown appendTo="body" formControlName="internalBrand" [options]="internalBrandOptions"
                                    [showClear]="true"
                                    [filter]="true"
                                    filterBy="label"
                                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                    [virtualScroll]="true"
                                    [virtualScrollItemSize]="40"
                                    >
                        </laas-dropdown>
                    </div>

                    <div class="col-12 md:col-6 lg:col-3 mb-3"><!-- 多筆輸入 料號 -->
                        <label>{{ 'OverDcSearch.Search.sku' | translate }}</label>
                        <p-chips formControlName="sku" separator=" " (onAdd)="chipsAdd($event, 'sku')">
                        </p-chips>
                    </div>

                    <div class="col-12 md:col-6 lg:col-3 mb-3"><!-- 多選 客戶代碼-->
                        <label>{{ 'OverDcSearch.Search.consigneeKey' | translate }}</label>
                        <laas-customer-dropdown
                                    formControlName="consigneeKey"
                                    [showToggleAll]="false"
                                    [isMultiple]="true"
                                    [showLabel]="false"
                                    [divClass]="'field'">
                        </laas-customer-dropdown>
                    </div>

                    <div class="col-12 md:col-6 lg:col-3 mb-3"><!-- y/n 生效狀態-->
                        <label>{{ 'OverDcSearch.Search.activeFlag' | translate }}</label>
                        <p-dropdown formControlName="activeFlag"
                                    [options]="commonOption"
                                    optionLabel="label"
                                    placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                        </p-dropdown>
                    </div>

                </div>

                <div>

                    <button
                            pButton
                            pRipple
                            label="{{ 'Common.Button.Search' | translate }}"
                            (click)="searchBtnClick($event)">
                    </button>
                    <button
                            pButton
                            pRipple
                            label="{{ 'Common.Button.Reset' | translate }}"
                            type="reset"
                            class="p-button-secondary ml-2">
                    </button>
                    <button
                            pButton
                            pRipple
                            icon="pi pi-file"
                            label="{{ 'Common.Button.Export' | translate }}"
                            class="ml-2"
                            (click)="exportBtnClick($event)">
                    </button>

                </div>

            </form>
        </p-accordionTab>
    </p-accordion>


    <div class="mt-2">

        <laas-data-table
            #OverDcDataTable
            [(selectedRows)]="selectRow"
            [defaultColumns]="tableColumns"
            [value]="tableValue"
            [totalRecords]="this.pageInfo.totalRecords"
            dataKey="rowId"
            (tableOnPage)="this.tablePageChange($event)"
            (tableOnSort)="this.tableSort($event)"
            [loading]="isLoading"
            [lazy]="true"
            (setPageSize)="setPageSize($event)"
            [rows]="5"
            styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;"
        >

            <ng-template
                    pTemplate="body"
                    let-columns="columns"
                    let-rowData
            >

                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.field">

                        <ng-container *ngSwitchCase="'brand'" class="p-fluid">
                            <div class="overflow-text">
                                {{ rowData[col.field] | optionsMapping: brandOptions | replaceNullWith: '-' }}
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchDefault class="p-fluid">
                            <ng-container [ngSwitch]="col.dataType">
                                <ng-container *ngSwitchCase="'date'">
                                    <div class="overflow-text">
                                        {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <div class="overflow-text">
                                        {{ rowData[col.field] | replaceNullWith:'-'}}
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </td>
            </ng-template>
        </laas-data-table>
    </div>
</p-card>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
